import React from 'react'

export const Footer = () => {
  return (
        <footer className="footer">
            &copy; Progen 2026 - <a href="https://enriquediazweb.com">enriquediazweb.com</a>
        </footer>
  )
}
